import { themeColorOptions } from '../consts/theme-color-loco'
import { ThemeCreateColorKeysType, ThemeCreateColorSet } from '../types/theme-interface'

function normalizeName(name: string): string {
  const normalizedName = name
    .split('-')
    .map((namePart, i) => (i === 0 ? namePart : namePart[0].toUpperCase() + namePart.slice(1)))
    .join('')

  return normalizedName
}

export function normalizeColorSet<T extends Record<string, unknown>>(
  colorSet: T,
): Partial<Record<ThemeCreateColorKeysType, string>> {
  const normalizedColorSet = Object.keys(themeColorOptions).reduce((acc, next) => {
    const normalizedName = normalizeName(next)
    const value = colorSet[next]
    if (typeof value === 'string') {
      acc[normalizedName as ThemeCreateColorKeysType] = value
    }
    return acc
  }, {} as ThemeCreateColorSet)

  return normalizedColorSet
}

export function normalizeErrorColorFieldName(fieldName: string): string {
  return fieldName.replaceAll(
    /[A-Z]+(?![a-z])|[A-Z]/g,
    (substr, isMatch) => (isMatch ? '-' : '') + substr.toLowerCase(),
  )
}
